<template>
  <div
    v-if="showLoadingState"
    key="loadingState"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
    key="productDiscountCodes"
  >
    <blockquote class="quote quote-products-primary quote-first">
      <p>
        {{ $t('mEditionProductDiscountCodes.quote') }}
      </p>
    </blockquote>

    <AtomButtonSecondary
      :button-secondary="buttonSecondary.create"
      @createDiscount="createDiscount"
    />

    <div
      v-if="productoCuponesDescuento.length > 0"
      class="m-table-primary"
    >
      <table>
        <tr>
          <th class="text-align-left">
            {{ $t('mEditionProductDiscountCodes.table.thCode') }}
          </th>
          <th class="text-align-center">
            {{ $t('mEditionProductDiscountCodes.table.thAmount') }}
          </th>
          <th class="text-align-center">
            {{ $t('mEditionProductDiscountCodes.table.thStart') }}
          </th>
          <th class="text-align-center">
            {{ $t('mEditionProductDiscountCodes.table.thEnd') }}
          </th>
          <th
            v-if="false"
            class="text-align-center"
            width="12%"
          >
            {{ $t('mEditionProductDiscountCodes.table.thEdit') }}
          </th>
          <th
            class="text-align-center"
            width="12%"
          >
            {{ $t('mEditionProductDiscountCodes.table.thDelete') }}
          </th>
        </tr>
        <tr
          v-for="descuento in productoCuponesDescuento"
          :key="descuento.id"
          class="row-data"
        >
          <td class="text-align-left">
            {{ descuento.codigo }}
          </td>
          <td class="text-align-center">
            {{ descuento.monto_descuento }} %
          </td>
          <td class="text-align-center text-transform-capitalize text-white-space-nowrap">
            {{
              descuento.fecha_inicio
              ? $moment.parseZone(descuento.fecha_inicio).format('D MMMM, YYYY')
              : $t('mEditionProductDiscountCodes.dateText.noStart')
            }}
          </td>
          <td class="text-align-center text-transform-capitalize text-white-space-nowrap">
            {{
              descuento.fecha_fin
              ? $moment.parseZone(descuento.fecha_fin).format('D MMMM, YYYY')
              : $t('mEditionProductDiscountCodes.dateText.noEnd')
            }}
          </td>
          <td
            v-if="false"
            class="text-align-center"
          >
            <AtomButtonIconRounded
              :button-icon-rounded="buttonIconRounded.edit"
              :element="descuento"
              @editDiscount="editDiscount(descuento)"
            />
          </td>
          <td class="text-align-center">
            <AtomButtonIconRounded
              :button-icon-rounded="buttonIconRounded.delete"
              :element="descuento"
              @showModal="$modal.showModal"
            />
          </td>
        </tr>
      </table>
      <MoleculePaginationPrimary :pagination="pagination"/>
    </div>

  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionProductDiscountCodes',

  components: {
    MoleculePaginationPrimary: () => import('@/components/molecules/MoleculePaginationPrimary')
  },

  data () {
    return {
      buttonIconRounded: {
        delete: {
          class: 'a-button-secondary a-button-danger-secondary a-button-icon-rounded a-tooltip-primary a-tooltip-bottom',
          component: 'MoleculeEditionProductDiscountCodesModalDelete',
          icon: 'far fa-trash-alt',
          method: 'showModal',
          tooltip: this.$t('mEditionProductDiscountCodes.tooltip.delete'),
          type: 'button'
        },

        edit: {
          class: 'a-button-secondary a-button-products-secondary a-button-icon-rounded a-tooltip-primary a-tooltip-bottom',
          component: '',
          icon: 'fas fa-pencil-alt',
          method: 'editDiscount',
          tooltip: this.$t('mEditionProductDiscountCodes.tooltip.edit'),
          type: 'button'
        }
      },

      buttonSecondary: {
        create: {
          class: 'a-button-products-secondary',
          component: '',
          icon: 'fas fa-plus',
          method: 'createDiscount',
          text: this.$t('mEditionProductDiscountCodes.buttonSecondary.createText'),
          type: 'button'
        }
      },

      pagination: {
        currentPage: 1,
        currentQuantity: 0,
        limit: 10,
        showLoadingState: false,
        totalPages: 1,
        totalQuantity: 0
      },

      productoCuponesDescuento: [],
      showLoadingState: true
    }
  },

  computed: {
    updatedData () {
      return this.$modal.updatedData
    }
  },

  watch: {
    updatedData () {
      this.readProductoCuponesDescuento()
    }
  },

  created () {
    this.readProductoCuponesDescuento()
  },

  methods: {
    createDiscount () {
      this.$router.push(`/${this.$t('rPaths.product')}/${this.$route.params.id}/${this.$t('mEditionMenu.product.discountCodes.subject')}/${this.$t('mEditionMenu.product.discountCodes.children.create.subedition')}`)
    },

    editDiscount (descuento) {
      this.$store.commit('setProductSelectedDiscount', descuento)
      this.$router.push(`/${this.$t('rPaths.product')}/${this.$route.params.id}/${this.$t('mEditionMenu.product.discountCodes.subject')}/${this.$t('mEditionMenu.product.discountCodes.children.edit.subedition')}`)
    },

    readProductoCuponesDescuento () {
      this.$services.read('producto', 'readProductoCuponesDescuento', {}, [this.$route.params.id])
        .then(response => {
          this.productoCuponesDescuento = response.data
          this.pagination.currentQuantity = this.productoCuponesDescuento.length
          this.pagination.totalQuantity = this.productoCuponesDescuento.length
          this.showLoadingState = false
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState = false
        })
    }
  }
}
</script>
